<template>
  <easy-page-template
      title="辞書に関して、何を行いますか？"
      subtitle="辞書に関して行うことを、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconSystemDictionaryCreate"
          title="個別辞書を作成する"
          @click="handleOpenCreateDictionary"
          block>
      </easy-nav>
      <simple-dialog
          v-model="dialogCreateDictionary.visible"
          title-text="個別辞書の作成"
          @close="handleCloseCreateDictionary">
        <dictionary-create-from
            dictionary-type="local">
        </dictionary-create-from>
      </simple-dialog>

      <easy-nav
          :icon="iconSystemDictionaryImport"
          title="外部辞書をインポートして作成する"
          @click="handleOpenRegisterExternalDictionary"
          block>
      </easy-nav>
      <simple-dialog
          v-model="dialogTokenImport.visible"
          title-text="外部辞書インポート"
          @close="handleCloseRegisterExternalDictionary">
        <token-import-form
          dictionary-type="external"
          @after-apply="handleAfterTokenImport">
        </token-import-form>
      </simple-dialog>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconSystemDictionaryCreate from "./assets/icon_system_dictionary_create.svg";
import iconSystemDictionaryImport from "./assets/icon_system_dictionary_import.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import TokenImportForm from "@/components/pages/dictionary/DictionaryList/TokenImportForm.vue";
import DictionaryCreateFrom from "@/components/pages/dictionary/DictionaryList/DictionaryCreateFrom.vue";

export default {
  name: "DictionaryCreation",
  components: {DictionaryCreateFrom, TokenImportForm, SimpleDialog, EasyNav, EasyPageTemplate},
  data() {
    return {
      iconSystemDictionaryCreate,
      iconSystemDictionaryImport,
      imageTradeContract,
      dialogCreateDictionary: {
        visible: false
      },
      dialogTokenImport: {
        visible: false
      }
    }
  },
  methods: {
    handleOpenCreateDictionary() {
      this.dialogCreateDictionary.visible = true;
    },
    handleCloseCreateDictionary() {
      this.dialogCreateDictionary.visible = false;
    },
    handleOpenRegisterExternalDictionary() {
      this.dialogTokenImport.visible = true;
    },
    handleCloseRegisterExternalDictionary() {
      this.dialogTokenImport.visible = false;
    },
    handleAfterTokenImport(dictionaryType) {
      if(dictionaryType === 'external') {
        this.$router.push({name: '/edit/external/dictionary/DictionaryList'});
      }
    },
  },
}
</script>

<style scoped>

</style>
